import React, { useEffect, useState } from 'react';
import API from '../../api';
import { useParams, useNavigate } from 'react-router-dom';
import MessageModal from '../smallComponent/MessageModal';
import { useCustomers } from '../context/CustomerContext';

const CustomerEditAfterDone = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [customer, setCustomer] = useState({
    customer_name: '',
    project_duration: '',
  });

  const [developers, setDevelopers] = useState([]);
  const [price, setPrice] = useState(0);
  const [quotation, setQuotation] = useState(null);
  const [workDetails, setWorkDetails] = useState('');
  const [doneDate, setDoneDate] = useState('');
  const [developerId, setDeveloperId] = useState('');
  const { fetchCustomers } = useCustomers();

  const [modal, setModal] = useState({ show: false, message: '', type: 'info', redirectPath: '' });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await API.get(`/customers/${id}`);
        const data = res.data;

        setCustomer({
          customer_name: data.customer_name || '',
          project_duration: data.project_duration || '',
        });

        setPrice(data.price || 0);
        setWorkDetails(data.work_details || '');
        setDoneDate(data.done_date?.substring(0, 10) || '');
        setDeveloperId(data.developerteam_id || '');
      } catch (err) {
        console.error("Customer fetch error:", err);
      }

      try {
        const devRes = await API.get(`/customers/users?department=Developer`);
        setDevelopers(devRes.data);
      } catch (err) {
        console.error("Developer fetch error:", err);
      }
    };

    fetchData();
  }, [id]);

  const handleCustomerChange = (e) => {
    const { name, value } = e.target;
    setCustomer(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('customer_name', customer.customer_name);
    formData.append('project_duration', customer.project_duration);
    formData.append('price', price);
    formData.append('upload_quatation', quotation);
    formData.append('work_details', workDetails);
    formData.append('done_date', doneDate);
    formData.append('developerteam_id', developerId);

    try {
      await API.put(`/customers/${id}/afterDone`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      setModal({
        show: true,
        message: '✅ Customer info updated successfully',
        type: 'success',
        redirectPath: '/dashboard/due-customer',
      });
      fetchCustomers();
    } catch (err) {
      console.error('Update error:', err);
      setModal({
        show: true,
        message: '❌ Update failed!',
        type: 'error',
        redirectPath: '',
      });
    }
  };

  const handleModalClose = () => {
    const redirect = modal.redirectPath;
    setModal({ show: false, message: '', type: 'info', redirectPath: '' });
    if (modal.type === 'success' && redirect) navigate(redirect);
  };

  return (
    <div className="max-w-5xl mx-auto mt-6 px-4">
      <div className="bg-yellow-100 border border-yellow-400 text-yellow-900 rounded-lg shadow-lg">
        <div className="bg-yellow-400 text-black text-lg font-bold px-6 py-3">
          🛠️ Update Done Customer Info
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block mb-1 font-medium">Customer Name</label>
              <input
                name="customer_name"
                value={customer.customer_name}
                onChange={handleCustomerChange}
                required
                className="w-full px-4 py-2 border rounded-md"
              />
            </div>
            <div>
              <label className="block mb-1 font-medium">Assign Developer</label>
              <select
                value={developerId}
                onChange={(e) => setDeveloperId(e.target.value)}
                required
                className="w-full px-4 py-2 border rounded-md"
              >
                <option value="">Select Developer</option>
                {developers.map(dev => (
                  <option key={dev.id} value={dev.id}>
                    {dev.name} {dev.email ? `(${dev.email})` : ''}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block mb-1 font-medium">Upload Quotation (PDF)</label>
              <input
                type="file"
                accept="application/pdf"
                onChange={(e) => setQuotation(e.target.files[0])}
                className="w-full"
              />
              {customer.upload_quatation && (
                <a
                  href={`http://localhost:5000/uploads/quotations/${customer.upload_quatation}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline mt-2 block"
                >
                  📄 View Existing Quotation
                </a>
              )}
            </div>
            <div>
              <label className="block mb-1 font-medium">Project Duration</label>
              <input
                name="project_duration"
                value={customer.project_duration}
                onChange={handleCustomerChange}
                className="w-full px-4 py-2 border rounded-md"
              />
            </div>
          </div>

          <div>
            <label className="block mb-1 font-medium">Work Details</label>
            <textarea
              rows={2}
              value={workDetails}
              onChange={(e) => setWorkDetails(e.target.value)}
              className="w-full px-4 py-2 border rounded-md"
            />
          </div>



          <div className="grid md:grid-cols-2 gap-4">
            <div>
            <label className="block mb-1 font-medium">Done Date</label>
            <input
              type="date"
              value={doneDate}
              onChange={(e) => setDoneDate(e.target.value)}
              required
              className="w-full px-4 py-2 border rounded-md"
            />
          </div>
            <div>
              <label className="block mb-1 font-medium">Price (₹)</label>
              <input
                type="number"
                value={price}
                onChange={(e) => setPrice(Number(e.target.value))}
                className="w-full px-4 py-2 border rounded-md"
              />
            </div>
          </div>

          <div className="flex justify-end">
            <button type="submit" className="bg-yellow-500 text-black font-semibold px-6 py-2 rounded hover:bg-yellow-600 transition">
              💾 Update
            </button>
          </div>
        </form>
      </div>

      <MessageModal
        show={modal.show}
        onClose={handleModalClose}
        title={modal.type === 'success' ? 'Success' : 'Error'}
        message={modal.message}
        type={modal.type}
      />
    </div>
  );
};

export default CustomerEditAfterDone;
